import { render, staticRenderFns } from "./BadWords.vue?vue&type=template&id=2af729c2&scoped=true"
import script from "./BadWords.vue?vue&type=script&lang=js"
export * from "./BadWords.vue?vue&type=script&lang=js"
import style0 from "./BadWords.vue?vue&type=style&index=0&id=2af729c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af729c2",
  null
  
)

export default component.exports